import {APIEvents} from "../../../constants/AnalyticsEventKeys";
import {MobileAnalyticsHelper} from "@amzn/dolphin-web-framework";
import {getNPSWClient} from "../../base/ClientInterface";

export function GetStagingAreaForPickListAPI(data, nextAction, errorAction, dispatcher) {
    let startTime = Date.now();
    getNPSWClient().getStagingAreaForPickList(data)
        .then(({success, data}) => {
            if (success) {
                dispatcher({
                    type: nextAction,
                    data: data,
                    dispatcher: dispatcher
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.StagingAreaForPicklist, startTime);
            } else {
                dispatcher({
                    type: errorAction,
                    dispatcher: dispatcher
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.StagingAreaForPicklist, startTime, true);
            }
        })
}